import { useParams } from "react-router-dom";
import { ListingPage } from "./ListingPage";

export function CategoryShortcutPage() {
  useParams();
  return <ListingPage type="category" />;
}
